// How the wallet tops itself up on its own, and what was consented to. `tenancy.billing.manage`
// on both.
//
// While the arrangement is on, the worker's `credit-renewal` opens a top-up whenever the balance is
// under the threshold and has it charged, with nobody present, on the card kept at a top-up paid
// with `save_instrument` (`docs/plans/billing-ledger.md` B8). Switching it on records the consent
// that charge rests on, with the wording's version; switching it off clears it.

import { api } from '../client'
import type { components } from '../schema'

export type AutoTopUpView = components['schemas']['AutoTopUpView']
export type SetAutoTopUpRequest = components['schemas']['SetAutoTopUpRequest']

/** The arrangement as it stands. */
export function readAutoTopUp(signal?: AbortSignal): Promise<AutoTopUpView> {
  return api.get<AutoTopUpView>('/orgs/current/credits/auto-top-up', undefined, signal)
}

/**
 * Set it, consent and all. A `PUT`: switching it on requires `threshold_cents`, `amount_cents`
 * **and** `consent_text_version` together — a card may not be charged off session on an
 * arrangement nobody recorded agreeing to — and switching it off clears all three, so switching it
 * on again is consenting again.
 */
export function updateAutoTopUp(body: SetAutoTopUpRequest): Promise<AutoTopUpView> {
  return api.put<AutoTopUpView>('/orgs/current/credits/auto-top-up', body)
}
